var installedModules = {};
var moduleToHandlerMapping = {
	1924: {
		getter: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	865: {
		getter: function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(884), __webpack_require__.e(715), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(6715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	3224: {
		getter: function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	9914: {
		getter: function() { return Promise.all([__webpack_require__.e(884), __webpack_require__.e(78), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(8133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	8006: {
		getter: function() { return Promise.all([__webpack_require__.e(965), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(9965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	4178: {
		getter: function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	1995: {
		getter: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(4848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	9434: {
		getter: function() { return function() { return __webpack_require__(6540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	8712: {
		getter: function() { return __webpack_require__.e(816).then(function() { return function() { return __webpack_require__(4435); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	7733: {
		getter: function() { return __webpack_require__.e(513).then(function() { return function() { return __webpack_require__(2513); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	230: {
		getter: function() { return function() { return __webpack_require__(5852); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.11.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@emotion/cache",
	},
	1483: {
		getter: function() { return function() { return __webpack_require__(196); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.10.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@emotion/react",
	},
	7070: {
		getter: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	7078: {
		getter: function() { return function() { return __webpack_require__(961); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	7266: {
		getter: function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	932: {
		getter: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	7303: {
		getter: function() { return function() { return __webpack_require__(5879); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.10.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@emotion/styled",
	},
	8088: {
		getter: function() { return __webpack_require__.e(106).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	8698: {
		getter: function() { return __webpack_require__.e(133).then(function() { return function() { return __webpack_require__(8133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	}
};
var initialConsumes = [1924,865,3224,9914,8006,4178,1995,9434,8712,7733,230,1483,1995,9434,7070,7078,230,1483,865,7266];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"78": [
		7078
	],
	"266": [
		7266
	],
	"527": [
		1924,
		865,
		3224,
		9914,
		8006,
		4178,
		1995,
		9434,
		8712,
		7733,
		230,
		1483
	],
	"556": [
		932,
		7303,
		8088,
		8698
	],
	"636": [
		865
	],
	"792": [
		1995,
		9434,
		7070,
		7078,
		230,
		1483
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}